import { render, staticRenderFns } from "./TransactionMob.vue?vue&type=template&id=35b57768"
import script from "./TransactionMob.vue?vue&type=script&lang=js"
export * from "./TransactionMob.vue?vue&type=script&lang=js"
import style0 from "./TransactionMob.vue?vue&type=style&index=0&id=35b57768&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports